
export const getIsWriteReviewModalOpen = (state) => {
  return state?.WriteReviewReducer?.isWriteReviewModalOpen;
};

export const getIsAddPhotoModalOpen = (state) => {
  return state?.WriteReviewReducer?.isAddPhotoModalOpen;
};

export const getIsAddVideoModalOpen = (state) => {
  return state?.WriteReviewReducer?.isAddVideoModalOpen;
};

export const getIsSubmissionFeedbackModalOpen = (state) => {
  return state?.WriteReviewReducer?.isSubmissionFeedbackModalOpen;
};

export const getProductDataForReview = (state) => {
  return state?.WriteReviewReducer?.productDataForReview;
};

export const getAddPhotoData = (state) => {
  return state?.WriteReviewReducer?.addPhotoData;
};

export const getAddVideoData = (state) => {
  return state?.WriteReviewReducer?.addVideoData;
};

export const getAddPhotoModalInitialData = (state) => {
  return state?.WriteReviewReducer?.addPhotoModalInitialData;
};

export const getAddVideoModalInitialData = (state) => {
  return state?.WriteReviewReducer?.addVideoModalInitialData;
};
